(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tulisan-halloween"] && !Shopify.designMode) return;
  try {
    const positionCurrency = () => {
  const box = document.querySelector('.buckscc-floating-box');
  const header = document.querySelector('.header');
  if (!box || !header) return;
  const target = header.querySelector(window.matchMedia('(max-width: 999px)').matches ? '.header__primary-nav' : '.header__secondary-nav');
  if (target && box.parentElement !== target) {
    if (window.matchMedia('(max-width: 999px)').matches) target.append(box);
    else target.prepend(box);
  }
};
positionCurrency();
let currencyFrame;
const currencyObserver = new MutationObserver(() => {
  if (currencyFrame) return;
  currencyFrame = requestAnimationFrame(() => { currencyFrame = null; positionCurrency(); });
});
currencyObserver.observe(document.body, {childList:true,subtree:true});
window.addEventListener('resize', positionCurrency);
document.addEventListener('shopify:section:load', positionCurrency);
  } catch(e) { console.error(e); }
})();

})();
